import { FC } from 'react'
import { Action } from 'actions'
import {
  CCActivateCardAction,
  CCLockCardAction,
  CCUnlockCardAction,
  DeleteCCAutoPaymentAction,
  DeleteCCPaymentAction,
  DeleteCCPaymentMethodAction,
  WithCardUid,
} from 'components/features/creditCard/creditCardStore/actions'
import { BaseDispatchButtonProps, DispatchButton } from 'components/features/pfm/Button/DispatchButton'
import { useStoreSelector } from 'helpers/reactReduxHelpers'
import { createActivateCardRequestSelector, currentCardSelector } from 'components/features/creditCard/creditCardStore/selectors'
import { toggleSettingsModalActionCreator } from 'actions/settingsActions'

/**========================================================================
 *                          CREDIT CARD ACTIONS
 *========================================================================**/

export type WithUidActionButtonProps =
  & BaseDispatchButtonProps
  & WithCardUid

export const ToggleCardLockActionButton: FC<BaseDispatchButtonProps> = (props) => {
  const card = useStoreSelector(currentCardSelector)
  if (!card) {
    return null
  }
  const { uid, status } = card
  const cardIsLocked = status === 'suspended'
  const cardIsLoading = status === 'processing'
  const action = cardIsLocked ? new CCUnlockCardAction({ uid }) : new CCLockCardAction({ uid })
  const text = (cardIsLocked ? 'Unlock' : 'Lock') + ' Your Card'
  return <DispatchButton actions={ [action] as Action[] } text={ text } isSubmitting={ cardIsLoading } { ...props } />
}
export const ActivateCardActionButton: FC<WithUidActionButtonProps> = ({ uid, ...otherProps }) => {
  const activateRequest = useStoreSelector(createActivateCardRequestSelector)
  const actions = [new CCActivateCardAction({ uid })]
  const cardIsLoading = activateRequest?.isLoading
  return <DispatchButton actions={ actions as Action[] } { ...otherProps } isSubmitting={ cardIsLoading } />
}

export const LockCardActionButton: FC<WithUidActionButtonProps> = ({ uid, ...otherProps }) => {
  const actions = [new CCLockCardAction({ uid })]
  return <DispatchButton actions={ actions as Action[] } { ...otherProps } />
}

export const UnlockCardActionButton: FC<WithUidActionButtonProps> = ({ uid, ...otherProps }) => {
  const actions = [new CCUnlockCardAction({ uid })]
  return <DispatchButton actions={ actions as Action[] } { ...otherProps } />
}

export const DeletePaymentMethodActionButton: FC<WithUidActionButtonProps> = ({ uid, ...otherProps }) => {
  const actions = [new DeleteCCPaymentMethodAction(uid)]
  return <DispatchButton actions={ actions as Action[] } { ...otherProps } />
}

export const DeletePaymentActionButton: FC<WithUidActionButtonProps> = ({ uid, ...otherProps }) => {
  const actions = [new DeleteCCPaymentAction(uid)]
  return <DispatchButton actions={ actions as Action[] } { ...otherProps } />
}

export const DeleteAutoPaymentActionButton: FC<BaseDispatchButtonProps> = (props) => {
  const actions = [new DeleteCCAutoPaymentAction()]
  return <DispatchButton actions={ actions as Action[] } { ...props } />
}

export const ShowOptOutModalActionButton: FC<BaseDispatchButtonProps> = (props) => {
  const actions = [toggleSettingsModalActionCreator({ type: 'opt-out' })]
  return <DispatchButton actions={ actions as Action[] } { ...props } />
}

